import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: 0,
    gap: theme.spacing(1),
  },
  locked: {
    cursor: 'not-allowed',
    '& *': { pointerEvents: 'none' },
  },
}))

export default useStyles
